import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FeaturesBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { secondaryBlockDefaultStyles } from "../../constants";

export const meta: ComponentMeta = {
  name: "Homepage Block 6",
  nameI18n: "builder_ui.block_type.homepage.block_6",
  version: 1,
  category: [FeaturesBlock],
  props: {
    header: {
      name: "Header",
      nameI18n: "builder_ui.prop_type.header",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    content: {
      name: "Content",
      nameI18n: "builder_ui.prop_type.content",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    cards: {
      name: "Cards",
      nameI18n: "builder_ui.prop_type.cards",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    footer: {
      name: "Footer",
      nameI18n: "builder_ui.prop_type.footer",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      prop: "styles",
      attributes: {
        backgroundColor: {
          ...backgroundColor,
          category: [DesignProp, GeneralProp],
          defaultValue: secondaryBlockDefaultStyles.backgroundColor,
        },
        backgroundImage: {
          ...backgroundImage,
          category: [DesignProp, GeneralProp],
        },
        padding: {
          ...padding,
          category: [DesignProp, PaddingsProp],
          defaultValue: secondaryBlockDefaultStyles.padding,
        },
        margin: {
          ...margin,
          category: [DesignProp, MarginsProp],
          defaultValue: secondaryBlockDefaultStyles.margin,
        },
      },
      type: "styles",
    },
  },
};
